// extracted by mini-css-extract-plugin
module.exports = {"layout":"SurveyTemplates_layout__3BoVq"};